/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sharereviewnotenetwork3Inputs */

const en_sharereviewnotenetwork3 = /** @type {(inputs: Sharereviewnotenetwork3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Many visits from one network`)
};

const de_sharereviewnotenetwork3 = /** @type {(inputs: Sharereviewnotenetwork3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Viele Besuche aus einem Netz`)
};

/**
* | output |
* | --- |
* | "Many visits from one network" |
*
* @param {Sharereviewnotenetwork3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const sharereviewnotenetwork3 = /** @type {((inputs?: Sharereviewnotenetwork3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sharereviewnotenetwork3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sharereviewnotenetwork3(inputs)
	return de_sharereviewnotenetwork3(inputs)
});
export { sharereviewnotenetwork3 as "shareReviewNoteNetwork" }